<template>
  <VuePDF
    ref="pdfViewer"
    :pdf="pdf"
    :page="currentPage"
    fit-parent
    @click="$emit('fullscreen')"
  />
  <div
    v-if="showPagination && pageCount > 1"
    class="row justify-center items-center"
  >
    <span class="q-mr-sm">{{ currentPage }} / {{ pageCount }}</span>
    <q-btn
      icon="keyboard_arrow_left"
      outline
      class="font-xsmall"
      :disable="currentPage === 1"
      @click="updateCurrentPage(-1)"
    />
    <q-btn
      icon="keyboard_arrow_right"
      outline
      class="font-xsmall q-ml-xs"
      :disable="currentPage === pageCount"
      @click="updateCurrentPage(1)"
    />
  </div>
</template>

<script setup>
import { usePDF, VuePDF } from '@tato30/vue-pdf';
import { onMounted } from 'vue';

const emit = defineEmits(['fullscreen', 'update:currentPage', 'loaded']);

const props = defineProps({
  pdfSrc: {
    type: String,
    required: true,
  },

  currentPage: {
    type: Number,
    required: true,
  },

  showPagination: {
    type: Boolean,
    default: true,
  },
});

const updateCurrentPage = (step) => {
  emit('update:currentPage', props.currentPage + step);
};

const { pdf, pages: pageCount } = usePDF(props.pdfSrc);

onMounted(() => emit('loaded'));
</script>
